module.exports = __webpack_public_path__ + "img/premium_offers.8e2c0c7f.webp";